import { CustomerType } from "@/api-schema-enums";
import { CustomerTable } from "@/components/data-table/predefined/customer-table/customer-table";
import { DataTableHeightMode } from "@/components/data-table/types";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import type { VehicleBuyInCustomer } from "../_helpers/vehicle-buy-in-form.helpers";

interface VehicleBuyInCustomerPrefillDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPrefill: (customer: VehicleBuyInCustomer) => void;
}

export function VehicleBuyInCustomerPrefillDialog({
  open,
  onOpenChange,
  onPrefill,
}: VehicleBuyInCustomerPrefillDialogProps) {
  const { t } = useTranslation(["fab", "common"]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="md:max-w-4xl lg:max-w-6xl">
        <DialogHeader>
          <DialogTitle>{t("fab:PrefillCustomerData")}</DialogTitle>
          <DialogDescription>{t("fab:PrefillCustomerDataDescription")}</DialogDescription>
        </DialogHeader>
        <div className="min-h-0">
          <CustomerTable
            name="vehicle-buy-in-customer-prefill-table"
            heightMode={DataTableHeightMode.Custom}
            className="h-[min(60vh,38rem)]"
            showCreateButton={false}
            customRowActions={null}
            features={{ expansion: false, multiSelection: false, pagination: true, search: true }}
            filters={[]}
            body={{
              type: [CustomerType.Private, CustomerType.Business],
              deletedAt: ["IS_NULL"],
            }}
            onRowClick={(customer) => {
              onPrefill(customer);
              onOpenChange(false);
            }}
            onRowNavigate={() => undefined}
            disableUrlPersistence
            noResultsTitle={t("fab:NoMatchingCustomers")}
            noResultsDescription={t("fab:NoMatchingCustomersDescription")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
